import { render, staticRenderFns } from "./TeamInvitePage.vue?vue&type=template&id=718fa9f7&scoped=true"
import script from "./TeamInvitePage.vue?vue&type=script&lang=js"
export * from "./TeamInvitePage.vue?vue&type=script&lang=js"
import style0 from "./TeamInvitePage.vue?vue&type=style&index=0&id=718fa9f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718fa9f7",
  null
  
)

export default component.exports